import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { AddKeyPressHandler } from '@gem/keyboard-handler';
import { useTranslation } from '@gem/modules/i18n';
import { ICommonPopupsProps, Popup, useClosePopupOnNavigation } from '@gem/popups';
import { Button, customScrollStyles, MenuItem, SwitchMenuItem } from '@gem/ui-kit';

import {
  useSpacePermissionsPopupPresenter,
  ISpacePermissionsPopupParams,
} from './SpacePermissionsPopup.presenter';
import styles from './SpacePermissionsPopup.styles.m.css';

type TSpacePermissionsPopupProps = ICommonPopupsProps<ISpacePermissionsPopupParams>;

export const SpacePermissionsPopup: FC<TSpacePermissionsPopupProps> = observer((props) => {
  const { t } = useTranslation();
  const presenter = useSpacePermissionsPopupPresenter(props);
  useClosePopupOnNavigation(props.popupInstance);

  return (
    <Popup
      title={t('permissions_label')}
      isOpened
      isHidden={props.popupInstance.isHidden}
      handlePrevStep={presenter.hasBackButton ? presenter.onBack : null}
      onClose={presenter.onClose}
    >
      <AddKeyPressHandler onEsc={presenter.onClose} />
      <div className={classNames(styles.content, customScrollStyles.container)}>
        {presenter.isShowCommentModerationSection && (
          <>
            <h6 className={styles.caption}>{t('comment_moderation_section')}</h6>
            <SwitchMenuItem
              className={styles.switchWithDescription}
              title={t('hide_offencive_words')}
              subTitle={t('comment_moderation_hide_description')}
              isChecked={presenter.obsceneFilterEnabled}
              onChange={presenter.onToggleObsceneFilter}
            />
            <MenuItem
              className={styles.switch}
              title={t('manage_offencive_words')}
              count={presenter.keywordsCount > 0 ? presenter.keywordsCount : undefined}
              onClick={presenter.onOpenKeywordFiltersPopup}
            />
          </>
        )}
      </div>

      <div className={styles.footer}>
        <Button
          onClick={presenter.onSave}
          className={styles.button}
          isDisabled={!presenter.isEdited}
          theme="primary"
        >
          {t('save')}
        </Button>
      </div>
    </Popup>
  );
});
